import React, {createContext, useState} from 'react';
import CategoryRefBlock from 'app/Models/Content/CategoryRefBlockData';
import DalpakItemBlockData from 'app/Models/Content/DalpakItemBlockData';
import NewDalpakItemBlockData from 'app/Models/Content/NewDalpakItemBlockData';

import OperationBoxItemBlockData from 'app/Models/Content/OperationBoxItemBlockData';
import FAQItemBlockData from 'app/Models/Content/FAQItemBlockData';

export type Category = {
  id: number;
  name: string;
  numberOfItemsPerRow: number;
};

const TheCounterContext = createContext<[Category, React.Dispatch<React.SetStateAction<Category>>]>(null);

type BlockFilterType = NewDalpakItemBlockData | DalpakItemBlockData | OperationBoxItemBlockData | FAQItemBlockData;

// if category is not found filter is off
export const categoryFilterFunc = (item: BlockFilterType, category: Category) =>
  category == null ? true : (item.relatedCategory?.expandedValue as CategoryRefBlock[])?.some((c) => c.id.value === category.id);

export const TheCounterProvider: React.FC = ({children}) => {
  const state = useState<Category>(null);
  return <TheCounterContext.Provider value={state}>{children}</TheCounterContext.Provider>;
};

export default TheCounterContext;
